export default "__VITE_ASSET__Dzvqtp36__"